<section class="ui_collapsemutiselect" ref="collapsemutiselect">
  <div class="collapsemutiselect" :class="{'height132' : division,'heightAuto' : heightAuto,'border':dataArr.length}">
    <div class="collapsemutiselect_singleAdd" @click="openModal()" v-if="!dataArr.length">
      <iCon iconClass="icon-add" class="singleAdd_icon"></iCon>

      <div>{{$t('__c3r_c9n.__selectDevicesOrGroup')}}</div>
    </div>
    <div class="collapsemutiselect_multiAdd" v-if="dataArr.length">
      <div class="collapsemutiselect_header">
        <div class="collapsemutiselect_header_title">
          {{$t('__c3r_c9n.__devicesOrGroupList')}}
        </div>
        <Button type="border" wd="mlg" custom="icon" @onClick="openModal()"
          :text="$t('__c3r_c9n.__selectDevicesOrGroup')" class="btn-inline multiAdd_btn" colors="main" theme="1">
          <template #icon>
            <iCon iconClass="icon-add" class="singleAdd_icon"></iCon>
          </template>
        </Button>
      </div>
      <div class="collapsemutiselect_list">
        <span v-for="(item, index) in data" :class="['each'+index ]" class="list_name"
          @click.stop="clickData($event,index,item)">
          {{item.name}}
        </span>
        <span v-for="(item, index) in fulfillArr" class="list_name dashEmpty"></span>
      </div>
    </div>
    <div class="collapsemutiselect_dropdown">
      <iCon iconClass="dropdown" :class="{'rotate_180': heightAuto}" @click="openBox" v-if="division"
        class="singleAdd_icon"></iCon>
    </div>
  </div>
  <div class="detailInfo" v-click-outside="handleFocusOut"
    :class="[(showDetail || showDetail == 0) && isMOdalEmpty  ? 'show':'noshow']" :style="itemClass">
    <div v-for="(item, index) in data">
      <div v-for="(each, name , i) in item" v-if="index == showDetail">
        <span v-if="each != item.name ">{{name}} : {{each}}</span>
      </div>
    </div>

  </div>
</section>